/**
 * 说话内容 配置
 * @constructor
 */
export default function TalkMsgConfig(){
    const dataList : TalkEntity[] = [
        //主食
        { talkNormalMsg : ["老板给我来杯喝的","老板你这里有什么可以解渴的给我呈上来!","渴死我了这里还有什么喝的?"],type : 1,typeName : "饮品" },
        { talkNormalMsg : ["老板随便给我做些吃的!","快点!我都饿坏了!赶紧上菜什么都行!","老板有什么招牌主食推荐？"],type : 1,typeName : "主食" },
        { talkNormalMsg : ["给我来份蛋糕","这里有什么甜的给我来一份","老板你这有什么蛋糕推荐一下呗！"] , type : 1 , typeName : "甜品" },

        //食材
        { talkNormalMsg : ["没错就是这个多来点。我最喜欢了。","这东西闻起来臭了点，吃起来那叫一个香！"],talkErrorMsg:["这是让人吃的吗？","你这是什么黑暗料理？？？"],type : 2,typeName : "奥利给" },
        { talkNormalMsg : ["这大热天还得是吃点冰的。","老板我还要点冰块！"],talkErrorMsg:["放那么多冰你是想冷死我吗？","你这是在冰箱里拿出来的吗？都是冰黑店！"],type : 2,typeName : "冰块" },
        { talkNormalMsg : ["还得你你们家的龙虾实在。","我的天呐！多新鲜的龙虾！"],talkErrorMsg:["你这龙虾一看就不新鲜！","龙虾那么小够谁吃的！"],type : 2,typeName : "龙虾" },
        { talkNormalMsg : ["这居然用的是真金子！我的天！","哦豁！用金子高端大气上档次。"],talkErrorMsg:["这点金子还那么抠门黑店！","一眼定真鉴定是假金子。"],type : 2,typeName : "黄金" },
        { talkNormalMsg : ["酸酸的柠檬最好吃了。","柠檬不管搭配什么都是又好看又好吃！"],talkErrorMsg:["你们这柠檬放了那么久还拿出来用拉黑！","老板你上辈子是醋坛子吧！放那么多柠檬酸死了。"],type : 2,typeName : "柠檬" },
        { talkNormalMsg : ["原生土鸡蛋，这可是好东西。","鸡蛋还得是自己养的鸡下的，吃的安心。"],talkErrorMsg:["这破鸡蛋还那么贵！","这鸡蛋还不如我哥哥家的大！"],type : 2,typeName : "土鸡蛋" },
        { talkNormalMsg : ["这大肠一看就很好吃。","这大肠真新鲜。"],talkErrorMsg:["你是不是故意没洗干净？","你这是根本没有洗吧！味道那么大！"],type : 2,typeName : "大肠" },
        { talkNormalMsg : ["哇，这效果不错。"],talkErrorMsg:["这效果可以啊"],type : 2,typeName : "空气瓶" },



        //特殊组合
        { talkNormalMsg : ["这让我想起了妈妈给我做的蛋炒饭，再给我多来几份。","老板你这蛋炒饭的手艺块赶上顶级大厨了啊！"] , type : 3 , typeName : "蛋炒饭" },
        { talkNormalMsg : ["海鲜炒饭仿佛让人身临海边一般！","老板再给我还一份海鲜炒饭！"] , type : 3 , typeName : "海鲜炒饭" },
        { talkNormalMsg : ["龙虾蛋糕好奇怪的搭配啊！来一个试试看。","这龙虾蛋糕的龙虾也是奶油做的吗？"] , type : 3 , typeName : "龙虾蛋糕" },

        { talkNormalMsg : ["可乐当然是要喝冰的才痛快","这大热天的一杯冰可乐太爽了!"] , type : 3 , typeName : "冰可乐" },
        { talkNormalMsg : ["矮油，不错喔！这就是我要的柠檬可乐。","柠檬可乐解暑又止渴。"] , type : 3 , typeName : "柠檬可乐" },
        { talkNormalMsg : ["没错就是这个味，那叫一个地道！给我来一份便饭。","美味便饭传统又正宗。"] , type : 3 , typeName : "便饭" },
        { talkNormalMsg : ["这难道是米其林中的超级黄金炒饭？还有多少我全要了。","这真的是黄金做的炒饭吗？"] , type : 3 , typeName : "黄金炒饭" },
        { talkNormalMsg : ["酸酸甜甜的味道让我回忆起了初恋，这酸柠蛋糕多少钱我要了","这酸柠蛋糕看真美味，再来一份。"] , type : 3 , typeName : "酸柠蛋糕" },
        { talkNormalMsg : ["黄金蛋糕？都是金子做的吗？给我来一份尝尝。","你这黄金蛋糕奶油是黄金做的?还是盘子是黄金做的?"] , type : 3 , typeName : "黄金蛋糕" },
        { talkNormalMsg : ["夏天还得喝柠檬冰可乐。","柠檬冰可乐可是咱的最爱！"] , type : 3 , typeName : "柠檬冰可乐" },
        { talkNormalMsg : ["嘿~好家伙！黄金甲！是妈妈的味道！我要了。","咱村里人就好黄金甲这一口！"] , type : 3 , typeName : "黄金甲" },
        { talkNormalMsg : ["哎呦喂！群英荟萃儿！这叫一个地道。咱村的人就喜欢这个。","这一大早上来一个群英荟萃那叫一个美！"] , type : 3 , typeName : "群英荟萃" },
        { talkNormalMsg : ["给我一杯还魂水！换我一生不会醉！","再来一杯还魂水！让我一直不会累！"] , type : 3 , typeName : "还魂水" },
        { talkNormalMsg : ["难道你就是食神？除了他这个世界上没有人还会做“世纪炒饭”了。这些我都要了。","这难道是传说中才有的世纪炒饭？"] , type : 3 , typeName : "世纪炒饭" },
        { talkNormalMsg : ["鎏金冰川仿佛让人身临冰川时代太爽了！这个我要了。","这只有“新东风”顶级大厨才会的“鎏金冰川”莫非你是！"] , type : 3 , typeName : "鎏金冰川" },
        { talkNormalMsg : ["怪味可乐好奇妙的感觉，再给我来一杯。","这怪味可乐的看起来真不错！"] , type : 3 , typeName : "怪味可乐" },
        { talkNormalMsg : ["这是什么？怪味炒饭？来一份。这是什么？怪味炒饭？来一份。...","这是什么奇妙搭配的怪味炒饭？我来一份！"] , type : 3 , typeName : "怪味炒饭" },
        { talkNormalMsg : ["怪味蛋糕还能这样搭配，给我来一份尝尝。","woc这是什么奇怪的怪味蛋糕，给我来一份试试"] , type : 3 , typeName : "怪味蛋糕" },
        { talkNormalMsg : ["哎呦喂~您这空气米饭那叫一个地道！咱啊就好这一口。","咱就是说这空气米饭还有吗？我都要了！"] , type : 3 , typeName : "空气米饭" },
        { talkNormalMsg : ["空气可乐？嗯~不错大自然的清香与可乐完美的结合，剩下的我都包了。","空气可乐，无糖，纵享美味，放心喝！"] , type : 3 , typeName : "空气可乐" },
        { talkNormalMsg : ["现代生活与森林的完美结合，不愧是空气蛋糕，店里的我全要了。","还得是吃空气蛋糕！咱吃别的咳嗽"] , type : 3 , typeName : "空气蛋糕" },
        { talkNormalMsg : ["这难道是传说中的“九转大肠”！这全部的我都包了。","你这“九转大肠”是故意还是不小心的？"] , type : 3 , typeName : "九转大肠" },

    ];
    return dataList;
}

/**
 * 说话实体
 */
export interface TalkEntity {
    talkNormalMsg : string[];//说话内容
    talkErrorMsg ?: string[];//错误 的说话文案
    type : number;//类型  1 主食 2 食材 3 套餐 4 档位
    typeName : string;// type 对应的值
}

/**
 * 获取随机的语言
 * @param type 类型
 * @param typeName 类型名称
 */
export function getRandomTalkMsg( type : number , typeName : string , answerType ?: number ){
    let talkEntity = TalkMsgConfig().find((item , index ,dataList) =>{
        return item.type == type && item.typeName == typeName;
    });
    if ( talkEntity ) {
        let msg : string = "";
        if ( !answerType ) {
            msg = talkEntity.talkNormalMsg [ Math.floor( Math.random() * talkEntity.talkNormalMsg.length ) ];
        }else{
            msg = talkEntity.talkErrorMsg [ Math.floor( Math.random() * talkEntity.talkErrorMsg.length ) ];
        }
        return msg;
    }
    return null;
}

/**
 * 内容 type设定
 */
export enum TALK_TYPE {
    STAPLE_FOOD = 1,//主食
    FOOD_MATERIAL = 2,//食材
    SET_MEAL = 3,//套餐
}
